<!-- 方案加价审核 -->
<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Pricing.Audit')"
    width="1000px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="price-dialog"
  >
    <div class="price-dialog-header">
      <div>
        <el-button no="onOK" type="primary" @click="onOK">{{ $t('Pricing.CONFIRM') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Back') }}</el-button>
      </div>
    </div>
    <div style="display: flex; margin: 10px">
      <span style="margin-top: 7px; margin-right: 10px;">{{ $t('Pricing.TariffRatingAtTheTimeOfMaintenance') }}</span>
      <cargo-advance-select
        no="level"
        :static-options="tiers"
        tag-name="label"
        tag-value="value"
        :default-value="level"
        :clearable="false"
        style="width: 200px"
        @parentCallBack="p=>{level=p.value}"
      />
    </div>
    <div style="margin: 10px">
      <el-checkbox no="cost" label="Cost" :disabled="true" checked />
      <el-checkbox no="tier1" label="Tier 1" :disabled="true" checked />
      <el-checkbox no="tier2" label="Tier 2" :disabled="true" checked />
      <el-checkbox no="tier3" label="Tier 3" :disabled="true" checked />
    </div>
    <markup-fcl-data-grid
      v-if="innerVisible"
      ref="markupFclDataGrid"
      :config-module="'22130202'"
      :row-data="rowData"
      :editable="false"
      :grid-options="gridOptions"
    />
  </el-dialog>
</template>

<script>

import MarkupFclDataGrid from '@/views/cargo/v0/Price/PriceFCL/components/PriceFCL/markupFclDataGrid'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { FclApproveSettings } from '@/views/cargo/v0/Price/PriceFCL/components/PriceFCL/fclApproveSettings'
import { approvePriceFclsWithAllTiers } from '@/api/price/priceFcl'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridPopSelectInput from '@/components/Cargo/Common/CargoAgGridPopSelectInput/index'
import { getLoading } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
export default {
  name: 'FclMarkupSchemeDialog',
  components: { CargoAdvanceSelect, MarkupFclDataGrid },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    selectedRows: {
      type: Array,
      default: () => []
    },
    isSpot: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      fullscreenLoading: null,
      tiers: PriceUtils.TIERS,
      rowData: [],
      cfg: {},
      level: '0',
      source: null,
      fclConfigUtil: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridPopSelectInput
        }
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    init(fclConfigUtil) {
      this.fclConfigUtil = fclConfigUtil
      if (this.fclConfigUtil['_isMarkupSettingsLoaded']) {
        this.onSettingsLoaded()
      }
      this.setData()
      // 默认选中
      this.$nextTick(() => {
        this.gridOptions.api.forEachLeafNode((node) => {
          node.setSelected(true)
        })
      })
    },
    onSettingsLoaded() {
      this.cfg = this.fclConfigUtil.markupCfg
      if (this.cfg === null) {
        if (this.fclConfigUtil.markupCfgDef) {
          this.cfg = {}
          this.fclConfigUtil.markupCfg = this.cfg
          if (this.fclConfigUtil.isHQManager()) {
            this.cfg.officeId = 1
          } else {
            this.cfg.officeId = this.$store.getters.currentOfficeId
          }
          this.cfg.isOverrideable = false
          this.cfg.configId = this.fclConfigUtil.markupCfgDef.configId
        } else {
          this.$message.warning(this.$t('Pricing.NoSetting'))
          return
        }
      }
      this.decodeSetting()
    },
    decodeSetting() {
      if (this.fclConfigUtil.markupCfg) {
        const cfg = this.fclConfigUtil.markupCfgValue['setting']
        const sources = []
        cfg.forEach(item => {
          const data = new FclApproveSettings(item)
          if (data.polType === 0) {
            data.polColumn = data.rol
          } else if (data.polType === 1) {
            data.polColumn = data.col
          } else if (data.polType === 2) {
            data.polColumn = data.pol
          }
          if (data.podType === 0) {
            data.podColumn = data.rod
          } else if (data.podType === 1) {
            data.podColumn = data.cod
          } else if (data.podType === 2) {
            data.podColumn = data.pod
          }
          sources.push(data)
        })
        this.source = sources
      } else {
        this.source = []
      }
    },
    setData() {
      if (this.source) {
        this.selectedRows.forEach(item => {
          PriceUtils.calcHashCode(item)
        })
        this.source.forEach(item => {
          item.calcHashCode()
        })
        const gridProvider = []
        for (const cfg of this.source) {
          for (const pf of this.selectedRows) {
            if (this.isOverlap(cfg, pf)) {
              gridProvider.push(cfg)
              break
            }
          }
        }
        this.rowData = gridProvider
      }
    },
    isOverlap(cfg, pf) {
      if (!cfg.polMap.hasOwnProperty('ALLRG')) {
        const polField = PriceUtils.getPolField(cfg.polType)
        if (!cfg.polMap.hasOwnProperty(pf[polField])) {
          return false
        }
      }
      if (!cfg.podMap.hasOwnProperty('ALLRG')) {
        const podField = PriceUtils.getPodField(cfg.podType)
        if (!cfg.podMap.hasOwnProperty(pf[podField])) {
          return false
        }
      }
      if (!(cfg.carrier === pf.carrier || cfg.carrier === 0)) {
        return false
      }
      if (!(cfg.freightType === pf.freightType || cfg.freightType === '')) {
        return false
      }
      if (!(cfg.vessel === pf.vessel || !cfg.vessel)) {
        return false
      }
      if (!(cfg.voyageFlight === pf.voyageFlight || !cfg.voyageFlight)) {
        return false
      }
      if (!(cfg.frequency === 0 || pf.isFrequency.search(cfg.frequency) > -1)) {
        return false
      }
      return true
    },
    async onOK() {
      const markupSelectRows = this.$refs['markupFclDataGrid'].loadSelectRows()
      if (!markupSelectRows || markupSelectRows.length === 0) {
        this.$message.warning(this.$t('Pricing.PlsSelectRule'))
        return
      }

      if (this.isSpot) {
        let flag = false
        await this.$confirm(this.$t('Pricing.ECommerceFareOfflineReminderContent'), this.$t('Pricing.ECommerceFareOfflineReminder'), {
          confirmButtonText: this.$t('Pricing.OK'),
          cancelButtonText: this.$t('Pricing.CANCEL'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
        }).catch(() => {
          flag = true
        })
        if (flag) {
          return
        }
      }
      const params = this.formatParams(markupSelectRows)
      this.fullscreenLoading = getLoading()
      approvePriceFclsWithAllTiers(params).then(res => {
        this.$message.success(this.$t('Pricing.SchemeAudit') + this.$t('Message.Success'))
        this.$emit('close')
        this.$emit('auditBack', this.selectedRows)
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    formatParams(markupSelectRows) {
      const params = []
      const map = {} // 防止匹配多个运价方案
      for (const markupSelectRow of markupSelectRows) {
        const markupsCost = [markupSelectRow.cost20 || 0, markupSelectRow.cost40 || 0, markupSelectRow.costHC || 0, markupSelectRow.cost45 || 0, markupSelectRow.cost40nor || 0, markupSelectRow.cost20nor || 0]
        const markups1 = [markupSelectRow.one20, markupSelectRow.one40, markupSelectRow.oneHC, markupSelectRow.one45, markupSelectRow.one40nor, markupSelectRow.one20nor]
        const markups2 = [markupSelectRow.two20, markupSelectRow.two40, markupSelectRow.twoHC, markupSelectRow.two45, markupSelectRow.two40nor, markupSelectRow.two20nor]
        const markups3 = [markupSelectRow.three20, markupSelectRow.three40, markupSelectRow.threeHC, markupSelectRow.three45, markupSelectRow.three40nor, markupSelectRow.three20nor]
        for (let i = 0; i < 5; i++) {
          const m1 = Number(markups1[i])
          const m2 = Number(markups2[i])
          const m3 = Number(markups3[i])
          if (m2 < m1) {
            this.$message.warning(this.$t('Pricing.Two_B_One'))
            return
          }
          if (m3 < m2) {
            this.$message.warning(this.$t('Pricing.Three_BE_Two'))
            return
          }
        }
        const uuids = []
        this.selectedRows.forEach(item => {
          if (!map.hasOwnProperty(item.uuid) && this.isOverlap(markupSelectRow, item)) {
            uuids.push(item.uuid)
            map[item.uuid] = true
          }
        })
        const markupTypes = [markupSelectRow.isAddBy1, markupSelectRow.isAddBy2, markupSelectRow.isAddBy3, markupSelectRow.isAddByCost]
        params.push({
          level: this.level,
          priceFclUuids: uuids,
          markupTypes: markupTypes,
          markupsTier1: markups1,
          markupsTier2: markups2,
          markupsTier3: markups3,
          markupsCost: markupsCost
        })
      }
      return params
    },
    onCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
</style>
